import classnames from 'classnames';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';

import useDashboardRoutes from 'dpl/breeder_dashboard/hooks/useDashboardRoutes';
import useCurrentUser from 'dpl/common/hooks/useCurrentUser';
import {
  BREEDER_CENTER_PATH,
  BREEDER_DOWNLOADS_PATH,
  BREEDER_EDIT_PROFILE_PATH,
  BREEDER_REFERRAL_LINKS_PATH,
  BREEDER_SETTINGS_ACCOUNT_PATH,
  BREEDER_SETTINGS_COMMUNICATIONS_PATH,
  BREEDER_SETTINGS_CONTRACT_PATH,
  BREEDER_SETTINGS_LISTING_STATUS_PATH,
  BREEDER_SETTINGS_NOTIFICATIONS_PATH,
  BREEDER_SETTINGS_PAYMENT_PATH,
  HOME_PATH
} from 'dpl/shared/constants/urls';

import NavMenuOptions from './NavMenuOptions';

export default function BreederNavMenuOptions({ className }) {
  const { user, logout } = useCurrentUser();
  const dashboardRoutes = useDashboardRoutes();

  const dashboardOptions = useMemo(
    () =>
      dashboardRoutes.map(
        ({ path, icon, title, notificationsCount, locked, isActive }) => ({
          className: isActive ? 'stone-700' : 'secondary',
          iconName: locked ? 'fetch-lock' : icon,
          label: title,
          url: locked ? null : path,
          ...(notificationsCount && {
            badge: { text: notificationsCount, color: 'stone', variant: 'dark' }
          })
        })
      ),
    [dashboardRoutes]
  );

  const breederOptions = useMemo(
    () =>
      [
        {
          iconName: 'fetch-edit-alt',
          label: 'Edit profile',
          url: BREEDER_EDIT_PROFILE_PATH
        },
        {
          iconName: 'fetch-view',
          label: 'View profile',
          url: user.profile_url
        },
        {
          iconName: 'fetch-profile',
          label: 'Account settings',
          url: BREEDER_SETTINGS_ACCOUNT_PATH
        },
        {
          iconName: 'fetch-bell',
          label: 'Notification settings',
          url: BREEDER_SETTINGS_NOTIFICATIONS_PATH
        },
        {
          iconName: 'fetch-message',
          label: 'Communications',
          url: BREEDER_SETTINGS_COMMUNICATIONS_PATH
        },
        {
          iconName: 'fetch-document',
          label: 'Contracts',
          url: BREEDER_SETTINGS_CONTRACT_PATH
        },
        {
          iconName: 'fetch-credit-card-shield',
          label: 'Payment settings',
          url: BREEDER_SETTINGS_PAYMENT_PATH,
          hidden: !user.payments_enabled
        },
        {
          iconName: 'fetch-application',
          label: 'Listing status',
          url: BREEDER_SETTINGS_LISTING_STATUS_PATH
        },
        {
          iconName: 'fetch-link',
          label: 'Referral links',
          url: BREEDER_REFERRAL_LINKS_PATH,
          hidden: !user.published
        },
        {
          iconName: 'fetch-download',
          label: 'Downloads',
          url: BREEDER_DOWNLOADS_PATH,
          hidden: !user.published
        },
        {
          iconName: 'fetch-info',
          label: 'Good Breeder Center',
          url: BREEDER_CENTER_PATH
        },
        {
          iconName: 'fetch-logout-web',
          label: 'Log out',
          onClick: async () => {
            await logout();
            window.location = HOME_PATH;
          }
        }
      ].filter(link => !link.hidden),
    [user]
  );

  return (
    <div className={classnames('BreederNavMenuOptions', className)}>
      <NavMenuOptions options={dashboardOptions} />
      <NavMenuOptions
        className="bt b--default pt3 mt3"
        options={breederOptions}
      />
    </div>
  );
}

BreederNavMenuOptions.propTypes = {
  className: PropTypes.string
};

BreederNavMenuOptions.defaultProps = {
  className: null
};
